import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'chart-ppf', 'ChartPpf', [["path",{"d":"M19 17c0 -6.075 -5.373 -11 -12 -11","key":"svg-0"}],["path",{"d":"M3 3v18h18","key":"svg-1"}]]);